module.exports = __webpack_public_path__ + "static/media/file-jpg.5e0fdb35.svg";